import type {Profile} from '@/apiTypes/profile';

/**
 * Single source of truth for whether a user's profile has the fields required
 * to skip the registration-info modal during the event-registration flow.
 *
 * When `skipRiderFields` is true (organizers that opt out of liability waiver
 * collection), only name + DOB are required.
 */
export function hasRegistrationInfo(
  profile: Profile,
  skipRiderFields: boolean
): boolean {
  const hasBasicInfo = !!(
    profile.firstName &&
    profile.lastName &&
    profile.dateOfBirth
  );
  if (skipRiderFields) return hasBasicInfo;
  return hasBasicInfo && !!profile.liabilityWaiverAcceptedAt;
}
